import { FC } from "react"

import { ButtonActionType, ButtonBlock, PromotionBlock } from "../types/types"

type Props = {
  block: ButtonBlock
  onChange: (patch: Partial<PromotionBlock>) => void
}

export const ButtonBlockEditor: FC<Props> = ({ block, onChange }) => {
  const props = block.props ?? {}

  const handleActionTypeChange = (value: ButtonActionType) => {
    onChange({
      props: {
        ...props,
        actionType: value,
        href: undefined,
        route: undefined,
        targetBlockId: undefined
      }
    })
  }

  return (
    <div className="space-y-3 border border-[rgba(255,255,255,0.12)] rounded-lg p-4 bg-[#050816]">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-sm">Button</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="label block mb-1 text-xs uppercase opacity-70">Label</label>
          <input
            className="input input-bordered w-full input-sm"
            value={props.label ?? ""}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  label: e.target.value
                }
              })
            }
            placeholder="Label"
          />
        </div>

        <div>
          <label className="label block mb-1 text-xs uppercase opacity-70">Style</label>
          <select
            className="select select-bordered w-full select-sm"
            value={props.variant ?? "primary"}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  variant: e.target.value as ButtonBlock["props"]["variant"]
                }
              })
            }
          >
            <option value="primary">Primary</option>
            <option value="secondary">Secondary</option>
            <option value="outline">Outline</option>
          </select>
        </div>

        <div>
          <label className="label block mb-1 text-xs uppercase opacity-70">Action type</label>
          <select
            className="select select-bordered w-full select-sm"
            value={props.actionType}
            onChange={(e) => handleActionTypeChange(e.target.value as ButtonActionType)}
          >
            <option value="link">External link</option>
            <option value="route">Internal route</option>
            <option value="scrollTo">Scroll to block</option>
          </select>
        </div>

        {props.actionType === "link" && (
          <div>
            <label className="label block mb-1 text-xs uppercase opacity-70">URL</label>
            <input
              className="input input-bordered w-full input-sm"
              value={props.href ?? ""}
              onChange={(e) =>
                onChange({
                  props: {
                    ...props,
                    href: e.target.value
                  }
                })
              }
              placeholder="https://example.com/promo"
            />
          </div>
        )}

        {props.actionType === "route" && (
          <div>
            <label className="label block mb-1 text-xs uppercase opacity-70">Route path</label>
            <input
              className="input input-bordered w-full input-sm"
              value={props.route ?? ""}
              onChange={(e) =>
                onChange({
                  props: {
                    ...props,
                    route: e.target.value
                  }
                })
              }
              placeholder="/casino"
            />
          </div>
        )}

        {props.actionType === "scrollTo" && (
          <div>
            <label className="label block mb-1 text-xs uppercase opacity-70">Target block ID</label>
            <input
              className="input input-bordered w-full input-sm"
              value={props.targetBlockId ?? ""}
              onChange={(e) =>
                onChange({
                  props: {
                    ...props,
                    targetBlockId: e.target.value
                  }
                })
              }
              placeholder="terms-block-id"
            />
            <p className="mt-1 text-[10px] opacity-60">Frontend can map this ID to a DOM element or promotion block.</p>
          </div>
        )}
      </div>
    </div>
  )
}
